import React from "react";
import { Link } from "react-router-dom";

const Blog = ({ data }) => {
  if (!data || data.length === 0) return null;

  return (
    <section id="blog" className="blog-section">
      <div style={{ marginBottom: "1.5rem" }} />
      <div className="container">
        {/* Breadcrumb */}
        <nav className="breadcrumb blog-breadcrumb-large-left">
          <Link to="/" className="breadcrumb-link">
            Home
          </Link>
          <span className="breadcrumb-separator"> &gt; </span>
          <span className="breadcrumb-current">Blog</span>
        </nav>

        <h2 className="blog-title">Insights to Empower Your Growth</h2>
        <div className="blog-cards">
          {data.map(({ image, title, date, views }, index) => (
            <div className="blog-card" key={index}>
              <img src={image} alt={title} className="blog-image" />
              <h3 className="blog-heading">{title}</h3>
              <div className="blog-meta">
                <span>{date}</span>
                <span>{views} views</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
